import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pdfBaseUrl: "https://blissing.s3-us-west-1.amazonaws.com/",
    showVideoUrl:
      "https://blissing.s3-us-west-1.amazonaws.com/the_show/WHY+BUY+BLISSING.mp4",
    forMarkOnlyPdf: "for_mark_only/8498656456615496/THE+BOOK+FOR+MARK+-+EN.pdf"
  },
  mutations: {},
  actions: {},
  modules: {}
});
